import clsx from "clsx";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Icon from "~/components/common/icon";
import Filter from "~/components/pages/section/filter";

import Breadcrumbs from "../../../common/breadcrumbs";
import Pagen from "../../../common/pagen";
import Product from "../product";
import styles from "./index.module.scss";

export default function LandingSectionBody({ section = {} }: any) {
  const { products, count, params, meta } = useSelector(
    (state: any) => state.section,
  );
  const [isShowMobileFilter, setShowMobileFilter] = useState(false);

  useEffect(() => {
    const body: any = document.querySelector("body");
    if (!isShowMobileFilter) {
      body.classList.remove("popup");
    } else {
      body.classList.add("popup");
    }
  }, [isShowMobileFilter]);

  // @ts-ignore
  return (
    <div className="container">
      <Breadcrumbs />
      <div className={styles.Content}>
        <div
          id="filter"
          className={clsx(
            styles.Side,
            isShowMobileFilter && styles.SideMobileVisible,
          )}
        >
          <div className={styles.Fitler}>
            <Filter
              sectionPageUrl={section.SECTION_PAGE_URL}
              isShowMobileFilter={isShowMobileFilter}
            />
          </div>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div
            className={styles.SideMobileButton}
            onClick={() => setShowMobileFilter(true)}
          >
            <span>Все фильтры</span>
            <Icon id="filter" fill="#333" />
          </div>
        </div>
        <div className={styles.Block}>
          {meta.seoTop && <div className={styles.SeoTop}>{meta.seoTop}</div>}

          <div className={clsx(styles.Products, styles.ProductsTable)}>
            {products.map((product: any) => (
              <Product data={product} key={product.ID} />
            ))}
            {products.length === 0 && (
              <span className={styles.Empty}>
                По заданным фильтрам нет товаров.
              </span>
            )}
          </div>
          <div className={styles.Bottom}>
            <Pagen
              count={count}
              size={params.pageSize}
              currentNum={params.pageNum}
              isShowShowMore
            />
          </div>
          {meta.seoBottom && (
            <div
              className={styles.SeoBottom}
              dangerouslySetInnerHTML={{ __html: meta.seoBottom }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
